import { AxiosResponse } from "axios";
import ParsedData from "../../models/common/ParsedData";
import CourseDTO from "../../models/CourseDTO";
import courseApiRequest from "../../utils/apiUtils/courseApiRequest";
import apiRequest from "../../utils/apiUtils/apiRequest";
import EnrollConfigurationsDTO from "../../models/EnrollConfigurationsDTO";


// export function getAllCourses() {
//     const url = "/api/courses";
//     return courseApiRequest.get(url).then((response: AxiosResponse) => {
//         return response;
//     });
// }

// export function addCourse(name: string, date: string, type: string) {
//     const url = "/api/course/add";
//     let courseToAdd = new CourseDTO();
//     courseToAdd.name = name;
//     courseToAdd.courseDate = date;
//     courseToAdd.type = type;
//     console.log(courseToAdd);
//     return courseApiRequest.post(url, courseToAdd).then((response: AxiosResponse) => {
//         return response;
//     });
// }

// export function deleteCourse(courseId: number) {
//     const url = "/api/courses/" + courseId;
//     return courseApiRequest.delete(url).then((response: AxiosResponse) => {
//         return response;
//     });
// }

export function importExcel(url: string, data: Array<ParsedData>) {
    return courseApiRequest.post(url, data).then((response: AxiosResponse) => {
        return response;
    });
}

// export function getAllEnrollsByCourse(courseId: number) {
//     const url = "/api/courses/enrollment/all/" + courseId;
//     return courseApiRequest.get(url).then((response: AxiosResponse) => {
//         return response;
//     });
// }

// export function checkPartnerEnrolls(courseId: number, data: EnrollConfigurationsDTO) {
//     const url = "/courses/registration/" + courseId;
//     return apiRequest.post(url, data).then((response: AxiosResponse) => {
//         return response;
//     });
// }